module.exports = __webpack_public_path__ + "static/media/token_fish_200.88880843.png";